import { ElMessage } from 'element-plus'

export const FORMAT_DATE = function (date, fmt) {
  if (!date) return;
  date = new Date(date);
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  // 遍历这个对象
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }

  function padLeftZero(str) {
    return ('00' + str).substr(str.length);
  }

  return fmt;
};
//简易深度拷贝方法
export const DEEPCOPY = function (obj) {
  return JSON.parse(JSON.stringify(obj))
};
//表单赋值
export const LOAD_DATA = function (init, info) {
  Object.keys(init).forEach(key => {
    if (info[key] || info[key] === 0 || info[key] === false) init[key] = info[key];
  });
};
/**
 * 列表下拉转化
 * list:需要转化的列表
 * val:需要转化的值
 * key:转化时的key名称
 * value:转化时的value名称
 * reverse:是否反向转化
 * */
export const CONVERSIONTABLE = function (list, val, key, value, reverse) {
  key = key || 'label';
  value = value || 'value';
  if (reverse) [key, value] = [value, key];
  let status = list.filter(obj => obj[value] === val)[0];
  return (status) ? status[key] : val;
};

/*
* store
* */
export const STORE = {
  //首字母大写
  CAPITALIZE: function (str) {
    return str.replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
  },
  //store each obj
  STATE_EACH: function (state, func) {
    let obj = {};
    let arr = Object.keys(state);
    arr.forEach(key => {
      func(obj, key);
    });
    return obj;
  },
  //store  get
  getters: function (state) {
    let { STATE_EACH, CAPITALIZE } = this
    return STATE_EACH(state, function (obj, key) {
      obj[`get${CAPITALIZE(key)}`] = function (state) {
        return state[key]
      }
    });
  },
  //store set
  setters: function (state) {
    let { STATE_EACH, CAPITALIZE } = this
    return STATE_EACH(state, function (obj, key) {
      obj[`set${CAPITALIZE(key)}`] = function (state, value) {
        return state[key] = value
      }
    });
  }
};


//节流
export const DEBOUNCE = function (fn, delay) {
  let timer = null;
  return function () {
    let args = arguments;
    let context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}


//es6去重 对象
export const UNIQUE = function (arr, key) {
  const res = new Map();
  return arr.filter((a) => !res.has(a[key]) && res.set(a[key], 1))
};

//字符串json转对象
export const PARSE = function (str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return undefined;
  }
}
//转对象中 数组属性名 对象
export const PARSE_MULTIPLE = function (arr, obj) {
  arr.forEach(key => {
    if (obj[key]) obj[key] = PARSE(obj[key]);
  });
  return obj;
}
//转对象中 数组属性名 字符串
export const STRINGIFY_MULTIPLE = function (arr, obj) {
  arr.forEach(key => {
    if (obj[key]) obj[key] = JSON.stringify(obj[key]);
  });
}

/*
* 获取相邻hex值
* 参考：https://blog.csdn.net/isea533/article/details/85860078
* */
export const ColorUtil = {
  rgb2hsl: function ({ R, G, B }) {
    let H, S, L;
    let var_R = (R / 255);
    let var_G = (G / 255);
    let var_B = (B / 255);

    let var_Min = Math.min(var_R, var_G, var_B)    //Min. value of RGB
    let var_Max = Math.max(var_R, var_G, var_B)    //Max. value of RGB
    let del_Max = var_Max - var_Min             //Delta RGB value

    L = (var_Max + var_Min) / 2

    if (del_Max == 0) {
      H = 0
      S = 0
    } else {
      if (L < 0.5) S = del_Max / (var_Max + var_Min)
      else S = del_Max / (2 - var_Max - var_Min)

      let del_R = (((var_Max - var_R) / 6) + (del_Max / 2)) / del_Max
      let del_G = (((var_Max - var_G) / 6) + (del_Max / 2)) / del_Max
      let del_B = (((var_Max - var_B) / 6) + (del_Max / 2)) / del_Max

      if (var_R == var_Max) H = del_B - del_G
      else if (var_G == var_Max) H = (1 / 3) + del_R - del_B
      else if (var_B == var_Max) H = (2 / 3) + del_G - del_R

      if (H < 0) H += 1
      if (H > 1) H -= 1
    }
    return { H, S, L };
  },
  Hue_2_RGB: function (v1, v2, vH) {
    if (vH < 0) vH += 1;
    if (vH > 1) vH -= 1;
    if ((6 * vH) < 1) return (v1 + (v2 - v1) * 6 * vH);
    if ((2 * vH) < 1) return (v2);
    if ((3 * vH) < 2) return (v1 + (v2 - v1) * ((2 / 3) - vH) * 6);
    return v1;
  },
  hsl2rgb: function ({ H, S, L }) {
    let { Hue_2_RGB } = ColorUtil;
    let R, G, B;
    if (S == 0) {
      R = L * 255;
      G = L * 255;
      B = L * 255;
    } else {
      let var_2, var_1;
      if (L < 0.5) var_2 = L * (1 + S);
      else var_2 = (L + S) - (S * L);

      var_1 = 2 * L - var_2;

      R = Math.round(255 * Hue_2_RGB(var_1, var_2, H + (1 / 3)));
      G = Math.round(255 * Hue_2_RGB(var_1, var_2, H));
      B = Math.round(255 * Hue_2_RGB(var_1, var_2, H - (1 / 3)));
    }
    return { R, G, B };
  },
  hex2rgb: function (hex) {
    if (hex.indexOf('#') != -1) {
      hex = hex.substr(1, 6);
    }
    let R = parseInt(hex.substr(0, 2), 16);
    let G = parseInt(hex.substr(2, 2), 16);
    let B = parseInt(hex.substr(4, 2), 16);
    return { R, G, B };
  },
  rgb2hex: function ({ R, G, B }) {
    let { dec2hex } = ColorUtil;
    return '#' + dec2hex(R) + dec2hex(G) + dec2hex(B);
  },
  dec2hex: function (dec) {
    return (dec + 0x100).toString(16).substr(1, 2).toUpperCase();
  }
}

//公用删除框
export const DELETE_CONFIRM = function ({ title, msg, ok, cancel, confirmButtonText = 'Delete', customClassCss = 'delete-confirm' }) {
  ELEMENT.MessageBox.confirm(msg, title, {
    customClass: customClassCss + ' delete-confirm',
    confirmButtonText,
    cancelButtonText: 'Cancel',
    center: true,
    closeOnClickModal: false,
    closeOnPressEscape: false
  }).then(() => {
    if (ok) ok();
  }).catch(() => {
    if (cancel) cancel();
  });
}

let lastMessage = null
let timer = null

//消息提示
export const MESSAGE_INFO = function (type = 'success', message) {
  const options = {
    success: {
      iconClass: 'el-icon-check',
      showClose: true,
    },
    warning: {
      iconClass: 'el-icon-warning',
      showClose: true
    },
    error: {
      duration: 2000,
      showClose: true,
      iconClass: 'el-icon-error'
    }
  };

  if (lastMessage) {
    lastMessage.close()
  }
  if (timer) clearTimeout(timer)

  timer = setTimeout(() => {
    lastMessage = ElMessage({
      message: message,
      type: type,
      offset: 90,
      customClass: 'sakura-info',
      showClose: true,
      onClose: () => {
        lastMessage = null
      }
    })
  }, 0)
}


/**
 * [isEqualIPAddress 判断两个IP地址是否在同一个网段]
 * @param {[String]} addr1 [地址一]
 * @param {[String]} addr2 [地址二]
 * @param {[String]} mask1 [子网掩码]
 * @param {[String]} mask2 [子网掩码]
 * @return {Boolean} [true or false]
 */
export const ISEQUAL_IPADDRESS = function (addr1, addr2, mask1, mask2) {
  if (!addr1 || !addr2 || !mask1 || !mask2) {
    return false;
  }
  let res1 = [], res2 = [], res3 = [], res4 = [], mask = '';
  addr1 = addr1.split('.');
  addr2 = addr2.split('.');
  mask1 = mask1.split('.');
  mask2 = mask2.split('.');
  for (let i = 0, ilen = addr1.length; i < ilen; i += 1) {
    res1.push(parseInt(addr1[i]) & parseInt(mask1[i]));
    res2.push(parseInt(addr2[i]) & parseInt(mask2[i]));
    if (mask1 >= mask2) {
      mask = mask2;
    } else {
      mask = mask1;
    }
    res3.push(parseInt(addr1[i]) & parseInt(mask[i]));
    res4.push(parseInt(addr2[i]) & parseInt(mask[i]));
  }
  let arg1 = (res1.join(".") == res2.join(".")) && (mask1 == mask2);
  let arg2 = (res3.join(".") == res4.join("."));
  return arg1 || arg2;
}

export function ipToInt(ip) {
  const p = String(ip).trim().split('.').map(Number);
  if (p.length !== 4 || p.some(n => !Number.isInteger(n) || n < 0 || n > 255)) return null;
  return ((p[0] << 24) >>> 0) | (p[1] << 16) | (p[2] << 8) | p[3];
}

export function maskToInt(mask) {
  if (mask === undefined || mask === null) return null;
  const s = String(mask).trim();
  if (/^(0|[1-9]\d?)$/.test(s)) {
    const len = Number(s);
    if (len < 0 || len > 32) return null;
    return len === 0 ? 0 : (0xFFFFFFFF << (32 - len)) >>> 0;
  }
  const m = ipToInt(s);
  if (m === null) return null;
  let seenZero = false;
  for (let i = 31; i >= 0; i--) {
    const bit = (m >>> i) & 1;
    if (seenZero && bit === 1) return null;
    if (bit === 0) seenZero = true;
  }
  return m >>> 0;
}

export function isSameSubnet(ip, mask) {
  const ipInt = ipToInt(ip);
  const mInt  = maskToInt(mask);
  return !(ipInt === null || mInt === null);

}

export function isNetworkOrBroadcast(targetIp, baseIp, mask) {
  const ipInt = ipToInt(baseIp);
  const tInt  = ipToInt(targetIp);
  const mInt  = maskToInt(mask);
  if (ipInt === null || tInt === null || mInt === null) return false;

  const network   = ipInt & mInt;
  const broadcast = network | (~mInt >>> 0);
  return tInt === network || tInt === broadcast;
}


export function isUsableHostIp(ip, mask) {
  function ipToInt(ip) {
    return ip.split('.').reduce((acc, octet) => (acc << 8) + Number(octet), 0) >>> 0;
  }

  function intToIp(int) {
    return [
      (int >>> 24) & 255,
      (int >>> 16) & 255,
      (int >>> 8) & 255,
      int & 255
    ].join('.');
  }

  function maskToPrefix(mask) {
    return ipToInt(mask).toString(2).replace(/0+$/, '').length;
  }

  function subnetInfo(ip, mask) {
    const ipInt = ipToInt(ip);
    const maskInt = ipToInt(mask);
    const prefix = maskToPrefix(mask);

    const network = ipInt & maskInt;
    const broadcast = network | (~maskInt >>> 0);

    return {
      ip: ip,
      mask: mask,
      prefix: prefix,
      network: intToIp(network),
      broadcast: intToIp(broadcast),
      firstHost: intToIp(network + 1),
      lastHost: intToIp(broadcast - 1),
      hostCount: (broadcast - network - 1)
    };
  }

  const _sub = subnetInfo(ip, mask)

  function ipInRange(ip, hostMin, hostMax) {
    const ipVal = ipToInt(ip);
    const minVal = ipToInt(hostMin);
    const maxVal = ipToInt(hostMax);

    return ipVal >= minVal && ipVal <= maxVal;
  }


  return ipInRange(ip, _sub.firstHost, _sub.lastHost)

}

export function isReserved(ip) {
  const ipInt = ipToInt(ip);
  if (ipInt === null) return true;

  const firstOctet = (ipInt >>> 24) & 0xFF;

  // 0.0.0.0/8:
  if (firstOctet === 0) return true;

  // 127.0.0.0/8: loopback
  if (firstOctet === 127) return true;

  // 224.0.0.0/4: multicast
  if (firstOctet >= 224 && firstOctet <= 239) return true;

  // 240.0.0.0/4: reserved / experimental
  if (firstOctet >= 240) return true;

  return false;
}

export const IS_CORRECT_IP_RANGE = function (ip, mask) {

  if (isReserved(ip)) return false;

  return isUsableHostIp(ip, mask);
}

/**
 * 处理12小时制 时分
 * */
export const DEAL_TIME = function (value, separator) {
  let arr = value.split(separator);
  if (parseInt(arr[0]) - 12 > 0 || (parseInt(arr[0]) == 12 && parseInt(arr[1]) > 0)) return `${ZERO_FILL(parseInt(arr[0]) - 12)}:${arr[1]} PM`;
  else return `${arr[0]}:${arr[1]} AM`;
}
//补零
export const ZERO_FILL = function (num) {
  if (parseInt(num) > 9) return num;
  else return `0${num}`;
}

/**
 * 异或加密
 * **/
export const XOR = function (param) {
  //如果参数是字符串类型就转换位字符数组类型
  if (typeof param == 'string') {
    param = param.split('');
  }

  let temp = 31; //字符转码

  for (let i = 0; i < param.length; i++) {
    param[i] = String.fromCharCode(temp ^ param[i].charCodeAt());
  }
  return param.join('');
}

/**
 * 获取mask
 * 根据ip
 * **/
export const QUERY_SUBNET_MASK = function (ip) {
  const arr = [
    { start: '0.0.0.0', end: '127.255.255.255', mask: '255.0.0.0' },
    { start: '128.0.0.0', end: '191.255.255.255', mask: '255.255.0.0' },
    { start: '192.0.0.0', end: '223.255.255.255', mask: '255.255.255.0' },
    { start: '224.0.0.0', end: '239.255.255.255', mask: '' },
    { start: '240.0.0.0', end: '255.255.255.255', mask: '' }
  ];
  let mask = '';
  arr.some(item => {
    if (ipToNumber(ip) >= ipToNumber(item.start) && ipToNumber(ip) <= ipToNumber(item.end)) {
      mask = item.mask;
      return true;
    }
  })
  return mask;
}

//ip转化数字
function ipToNumber(ip) {
  let numbers = ip.split(".");
  return parseInt(numbers[0]) * 256 * 256 * 256 + parseInt(numbers[1]) * 256 * 256 + parseInt(numbers[2]) * 256 + parseInt(numbers[3]);
}

//数字转化ip
function numberToIp(number) {
  return (Math.floor(number / (256 * 256 * 256))) + "." + (Math.floor(number % (256 * 256 * 256) / (256 * 256))) + "." + (Math.floor(number % (256 * 256) / 256)) + "." + (Math.floor(number % 256));
}

//根据设备型号
export const INIT_NETWORK_COLUMN = function (model = '') {
  let column = 0;
  let mode = '';
  let arr1 = ['M4250-10G2F-POE+', 'M4250-10G2XF-POE+', 'M4250-10G2XF-POE++', 'M4250-12M2XF', 'M4250-16XF', 'M4250-8G2XF-POE+', 'M4250-9G1F-POE+', 'M4350-8M2V', 'M4350-16C'];
  let arr2 = ['M4250-26G4F-POE+', 'M4250-26G4XF-POE+', 'M4250-26G4F-POE++', 'M4300-8X8F', 'M4300-16X', 'M4300-12X12F', 'M4300-24X', 'M4300-24XF', 'M4300-24X24F', 'M4300-48X', 'M4300-48XF', 'M4300-28G', 'M4300-52G', 'M4300-28G-POE+', 'M4300-52G-POE+', 'M4350-24G4XF', 'M4350-48G4XF', 'M4350-44M4X4V', 'M4350-8X8F', 'M4350-12X12F', 'M4350-24X4V', 'M4350-24F4V', 'M4500-32C', 'M4500-48XF8C', 'M4350-40X4C', 'M4350-24X8F8V', 'M4350-32F8V', 'M4350-36X4V', 'M4350-16V4C', 'M4350-24F4X', 'M4350-24M4X4V', 'M4350-40F4C', 'MS424TXUP', 'GS424TPPv3'];
  let arr4 = ['M4250-40G8F-POE+', 'M4250-40G8XF-POE+', 'M4250-40G8XF-POE++'];
  let arrLarge = ['M4300-96X'];
  let frontBackArr = ['M4350-16M4V'];
  if (arr1.filter(key => key.toUpperCase() == model.toUpperCase()).length) {
    column = 1;
    mode = 'oneRowPanel';
  } else if (arr2.filter(key => key.toUpperCase() == model.toUpperCase()).length) {
    column = 2;
    mode = 'twoRowPanel';
  } else if (arr4.filter(key => key.toUpperCase() == model.toUpperCase()).length) {
    column = 4;
    mode = 'fourRowPanel';
  } else if (arrLarge.filter(key => key.toUpperCase() == model.toUpperCase()).length) {
    column = 4;
    mode = 'largeRowPanel';
  }  else if (frontBackArr.filter(key => key.toUpperCase() == model.toUpperCase()).length) {
    column = 5;
    mode = 'frontBackPanel';
  }
  return { column, mode }
}


/**
 *　　把IP地址转换成二进制格式
 *　　@param string   ip    待转换的IP的地址
 */
export const IP_TO_BINARY = function (ip) {
  let ip_str = "", ip_arr = ip.split(".");
  for (let i = 0; i < 4; i++) {
    let curr_num = ip_arr[i];
    let number_bin = parseInt(curr_num);
    number_bin = number_bin.toString(2);
    let count = 8 - number_bin.length;
    for (let j = 0; j < count; j++) {
      number_bin = "0" + number_bin;
    }
    ip_str += number_bin;
  }
  return ip_str;
}

/**
 *　　把二进制格式转换成IP地址
 *　　@param string   binary    待转换的二进制　　
 */
export const BINARY_TO_IP = function (binary) {
  let a, b, c, d;
  if (binary.length == 32) {
    a = parseInt(binary.substr(0, 8), 2);
    b = parseInt(binary.substr(8, 8), 2);
    c = parseInt(binary.substr(16, 8), 2);
    d = parseInt(binary.slice(-8), 2);
    return a + '.' + b + '.' + c + '.' + d;
  }
  return '';
}


/**
 *　　根据子网掩码和网关计算网络地址和广播地址
 *　　@param  string    mask    子网掩码
 *　　@param  string    gateway 网关
 */
export const GET_NETWORK_BROADCAST_ADDR = function (mask, ip) {
  let network_broadcast = [];
  let network_addr = "";

  let mask_arr = mask.split(".");
  let ip_arr = ip.split(".");

  // 计算IP的网络地址 与(&)运算
  for (let i = 0; i < 4; i++) {
    let number1 = parseInt(mask_arr[i]);
    let number2 = parseInt(ip_arr[i]);
    network_addr += number1 & number2;
    if (i < 3) {
      network_addr += ".";
    }
  }
  let min = ipToNumber(network_addr) + 1;
  network_broadcast.push(numberToIp(min));

  // 计算广播地址
  // 子掩码后面有几个0，就去掉IP地址后几位再补1
  let mask_binary = IP_TO_BINARY(mask);
  let gateway_binary = IP_TO_BINARY(ip);

  let mask_zero = mask_binary.split(0).length - 1;
  let one_number = new Array(mask_zero + 1).join('1'); // IP地址后位补1
  let gateway_hou_wei_bu_yi = gateway_binary.slice(0, -mask_zero) + one_number;
  let max = ipToNumber(BINARY_TO_IP(gateway_hou_wei_bu_yi)) - 1;
  network_broadcast.push(numberToIp(max));

  return network_broadcast;
}

/*
* 数组比较
* diff差集
* intersect交集
* complement补集
* union并集
* */
export const DOUBLE = {
  diff(arr1, arr2, key) {
    if (key) arr2 = arr2.map(item => item[key]);
    return arr1.filter(val => arr2.indexOf((key) ? val[key] : val) === -1);
  },
  intersect(arr1, arr2, key) {
    if (key) arr2 = arr2.map(item => item[key]);
    return arr1.filter(val => arr2.indexOf((key) ? val[key] : val) > -1);
  },
  complement(arr1, arr2, key) {
    let arr = [];
    return arr1.filter((val) => {
      if (key) arr = arr2.map(item => item[key]);
      return !(arr.indexOf((key) ? val[key] : val) > -1);
    }).concat(arr2.filter((val) => {
      if (key) arr = arr1.map(item => item[key]);
      return !(arr.indexOf((key) ? val[key] : val) > -1);
    }));
  },
  union(arr1, arr2, key) {
    let arr = [];
    return arr1.concat(arr2.filter((val) => {
      if (key) arr = arr1.map(item => item[key]);
      return !(arr.indexOf((key) ? val[key] : val) > -1);
    }));
  },
};
/*
* 小数运算
* */
export const DECIMAL_UFUNC = {
  add_num(num1, num2) {
    let baseNum, baseNum1, baseNum2;
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    return (num1 * baseNum + num2 * baseNum) / baseNum;
  },
  sub_num(num1, num2) {
    let baseNum, baseNum1, baseNum2;
    let precision;// 精度
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
    return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
  },
  acc_mul(arg1, arg2) {//乘法
    let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length
    } catch (e) {
    }
    try {
      m += s2.split(".")[1].length
    } catch (e) {
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  },
  acc_div(arg1, arg2) {//除法
    let t1 = 0, t2 = 0, r1, r2;
    try {
      t1 = arg1.toString().split(".")[1].length
    } catch (e) {
    }
    try {
      t2 = arg2.toString().split(".")[1].length
    } catch (e) {
    }
    r1 = Number(arg1.toString().replace(".", ""))
    r2 = Number(arg2.toString().replace(".", ""))
    return DECIMAL_UFUNC.acc_mul((r1 / r2), Math.pow(10, t2 - t1));
  }
};


/*
* 获取shure创建默认值对象
* 根据设备型号
* */
const CREATE_ARRAY = function () {
  let shure1 = [];
  let shure2 = [];
  let shure3 = [];
  let control1 = [];
  let control2 = [];
  let control3 = [];
  for (let i = 1; i < 49; i++) {
    if (i < 9) {
      shure1.push(i);
    }
    if (i < 25) {
      shure2.push(i);
    }
    if (i < 39) {
      shure3.push(i);
    }
    if (i == 9 || i == 11 || i == 12) {
      control1.push(i);
    }
    if (i == 25 || (i >= 27 && i <= 30)) {
      control2.push(i);
    }
    if (i == 39 || (i >= 41 && i <= 48)) {
      control3.push(i);
    }
  }
  return { shure1, shure2, shure3, control1, control2, control3 };
}
export const SHURE_DEFAULT = function (model) {
  let { shure1, shure2, shure3, control1, control2, control3 } = CREATE_ARRAY();
  let arr = [
    { model: 'M4250-10G2F-POE+', shureDevice: shure1, controlUntag: control1, audioUntag: [10] },
    { model: 'M4250-10G2XF-POE+', shureDevice: shure1, controlUntag: control1, audioUntag: [10] },
    { model: 'M4250-10G2XF-POE++', shureDevice: shure1, controlUntag: control1, audioUntag: [10] },
    { model: 'M4250-26G4F-POE+', shureDevice: shure2, controlUntag: control2, audioUntag: [26] },
    { model: 'M4250-26G4XF-POE+', shureDevice: shure2, controlUntag: control2, audioUntag: [26] },
    { model: 'M4250-26G4F-POE++', shureDevice: shure2, controlUntag: control2, audioUntag: [26] },
    { model: 'M4250-40G8F-POE+', shureDevice: shure3, controlUntag: control3, audioUntag: [40] },
    { model: 'M4250-40G8XF-POE+', shureDevice: shure3, controlUntag: control3, audioUntag: [40] },
    { model: 'M4250-40G8XF-POE++', shureDevice: shure3, controlUntag: control3, audioUntag: [40] },
    { model: 'M4250-12M2XF', shureDevice: [], controlUntag: [0], audioUntag: [] },
    { model: 'M4250-16XF', shureDevice: [], controlUntag: [0], audioUntag: [] },
    { model: 'M4250-8G2XF-POE+', shureDevice: shure1, controlUntag: [9], audioUntag: [10] },
    { model: 'M4250-9G1F-POE+', shureDevice: shure1, controlUntag: [9], audioUntag: [10] },
  ];
  let [node] = arr.filter(item => item.model == model.toUpperCase());
  return node;
}


/**
 * Format hostname for URL with port
 * Wraps IPv6 addresses in brackets as required by URL specification
 * @param {string} hostname - The hostname to format
 * @returns {string} - Formatted hostname safe for URL with port
 */
export const formatHostForUrl = function (hostname) {
  // Check if it's an IPv6 address (contains colons and is not already bracketed)
  if (hostname && hostname.includes(':') && !hostname.startsWith('[')) {
    return `[${hostname}]`;
  }
  return hostname;
};

//获取url参数
export const GET_REQUEST = function () {
  let obj = {};
  let str = location.href.split('?')[1];
  if (str) {
    let arr = str.split('&');
    arr.forEach(item => {
      let [key, name] = unescape(item).split('=');
      if (key) obj[key] = name;
    })
  }
  return obj;
}


//端口过滤器
export const LIST_FILTER = function (callback, list) {
  let portList = [];
  return DEEPCOPY(list).filter(item => {
    portList = item.port.filter((obj, index) => {
      return callback(obj, index);
    });
    return !!portList.length;
  }).map(item => {
    item.port = portList;
    return item;
  });
};
//获取具体面板评级数据
export const QUERY_PORT_LIST = function (list) {
  let li = DEEPCOPY(list).map(item => item.port);
  if (li.length == 0) return [];
  return li.reduce((a, b) => {
    return [...a].concat([...b])
  });
}

//type all/start/end
const create_speed = function (list, ranges) {
  let range = [];
  if (ranges) {
    let [start, end] = ranges;
    for (let i = start; i < end + 1; i++) {
      range.push(i);
    }
  }
  return { list, range }
}
//获取speed下拉值
/*  {"M4250-16XF","XSM4216F"},
    {"M4250-12M2XF","MSM4214X"},
    {"M4250-10G2XF-PoE++","GSM4212UX"},
    {"M4250-10G2F-PoE+","GSM4212P"},
    {"M4250-10G2XF-PoE+","GSM4212PX"},
    {"M4250-26G4F-PoE+","GSM4230P"},
    {"M4250-26G4XF-PoE+","GSM4230PX"},
    {"M4250-26G4F-PoE++","GSM4230UP"},
    {"M4250-40G8F-PoE+","GSM4248P"},
    {"M4250-40G8XF-PoE+","GSM4248PX"},
    {"M4250-40G8XF-PoE++","GSM4248UX"},
    {"M4250-8G2XF-PoE+","GSM4210PX"},
    {"M4250-9G1F-PoE+","GSM4210PD"},
    {"M4300-8X8F","XSM4316S"},
    {"M4300-16X","XSM4316PS"},
    {"M4300-12X12F","XSM4324S"},
    {"M4300-24X","XSM4324CS"},
    {"M4300-24XF","XSM4324FS"},
    {"M4300-24X24F","XSM4348S"},
    {"M4300-48X","XSM4348CS"},
    {"M4300-48XF","XSM4348FS"},
    {"M4300-96X","XSM4396S"},
    {"M4300-28G","GSM4328S"},
    {"M4300-52G","GSM4352S"},
    {"M4300-28G-PoE+","GSM4328PS"},
    {"M4300-52G-PoE+","GSM4352PS"},*/
export const SPEED_LIST = function (model, number) {
  let enums = DEEPCOPY(Vue.prototype.$sakura.locale.conversion.speed_state);
  const map = new Map();
  let start1 = ['Auto', '100 Full', '100 Half', '1G Full', '1G Half'];
  let start2 = ['Auto', '100 Full', '1G Full', '2.5G Full'];
  let end1 = ['Auto', '1G Full', '10G Full'];
  //GSM4210PD
  // GSM4212P
  // GSM4248P
  let obj1 = create_speed(start1)
  map.set('M4250-9G1F-POE+', [obj1])
  map.set('M4250-10G2F-POE+', [obj1])
  map.set('M4250-40G8F-POE+', [obj1])
  // XSM4216F
  // GSM4230P
  let obj2 = create_speed(end1)
  map.set('M4250-16XF', [obj2])
  map.set('M4250-26G4F-POE+', [obj2])
  //GSM4210PX
  let obj3 = create_speed(start1, [1, 8])
  let obj4 = create_speed(end1, [9, 10])
  map.set('M4250-8G2XF-POE+', [obj3, obj4])
  //GSM4212PX
  let obj5 = create_speed(start1, [1, 10])
  let obj6 = create_speed(end1, [11, 12])
  map.set('M4250-10G2XF-POE+', [obj5, obj6])
  //GSM4212UX
  let obj7 = create_speed(start1, [1, 10])
  let obj8 = create_speed(end1, [11, 12])
  map.set('M4250-10G2XF-POE++', [obj7, obj8])
  //MSM4214X
  let obj9 = create_speed(start2, [1, 12])
  let obj10 = create_speed(end1, [13, 14])
  map.set('M4250-12M2XF', [obj9, obj10])
  //GSM4230PX
  let obj11 = create_speed(start1, [1, 26])
  let obj12 = create_speed(end1, [27, 30])
  map.set('M4250-26G4XF-POE+', [obj11, obj12])
  //GSM4230UP
  let obj13 = create_speed(start1, [1, 26])
  let obj14 = create_speed(end1, [27, 30])
  map.set('M4250-26G4F-POE++', [obj13, obj14])
  //GSM4248PX
  let obj15 = create_speed(start1, [1, 40])
  let obj16 = create_speed(end1, [41, 48])
  map.set('M4250-40G8XF-POE+', [obj15, obj16])
  //GSM4248UX
  let obj17 = create_speed(start1, [1, 40])
  let obj18 = create_speed(end1, [41, 48])
  map.set('M4250-40G8XF-POE++', [obj17, obj18])

  let original = map.get(model.toUpperCase());
  let [node] = original;
  if (number) {
    let obj = original.filter(item => item.range.indexOf(number) >= 0)[0];
    if (obj) node = obj;
  }
  return node.list.map(key => enums.filter(obj => obj.value == key)[0]);
}


export const PROFILETYPE_FILTER = function (value) {
  let map = new Map([
    ['Video NDI5 with Dante,Q-Sys or AES67 audio', 'Video NDI5 / NDI6 with Dante, Q-Sys or AES67 audio'],
    ['Waves Soundgrid', 'Audio Soundgrid'],
    ['Allen & Heath gigaACEGX', 'Allen & Heath gigaACE/GX'],
    ['Telos AllianceLivewire+ AES67', 'Telos Alliance / Livewire+ AES67']
  ]);
  return (map.has(value)) ? map.get(value) : value;
}

export const CHECK_SHURE = function (profileType = '') {
  return profileType.toLocaleLowerCase() == 'Shure Split Audio and Control Network'.toLocaleLowerCase();
}

export const CHECK_SHURE_BROTHER = function (profileType = '') {
  return profileType.toLocaleLowerCase() == 'Shure Converged Audio and Control Network'.toLocaleLowerCase();
}

export const CHECK_KRAMER = function (profileType = '') {
  return profileType.toLocaleLowerCase() == 'Kramer AV'.toLocaleLowerCase();
}

export const VLANTYPE_MAP = function (vlanType) {
  const map = new Map([
    [1, ''],
    [2, 'control'],
    [3, 'audio'],
    [4, 'video'],
    [5, 'exp'], // Visionary Advanced Multi-Domain
    [6, 'stream'],//kramer_stream
    [7, 'control'],//kramer_control
    [8, 'audio'],//kramer_audio
    [9, 'aux']//kramer_aux
  ]);
  return map.get(vlanType)
}

export const SPEED_MAP = function (portCapability) {
  const map = new Map([
    [1, 'CAP_PORTSPEED_10'],
    [2, 'CAP_PORTSPEED_100'],
    [3, 'CAP_PORTSPEED_1000'],//S
    [4, 'CAP_PORTSPEED_2P5G'],
    [5, 'CAP_PORTSPEED_5G'],
    [6, 'CAP_PORTSPEED_10G'],//S+
    [7, 'CAP_PORTSPEED_20G'],
    [8, 'CAP_PORTSPEED_25G'],//S28
    [9, 'CAP_PORTSPEED_40G'],//QS+
    [10, 'CAP_PORTSPEED_50G'],//S56
    [11, 'CAP_PORTSPEED_100G']//Q28
  ]);
  return map.get(portCapability)
}

export const CHECK_POLY = (profileType = '') => {
  return profileType.toLocaleLowerCase() == 'Poly StudioNet Modular Room switch'.toLocaleLowerCase();
}

export const CHECK_AVID = (profileType = '') => {
  return profileType.toLocaleLowerCase() == 'Avid S6L'.toLocaleLowerCase();
}

export const CHECK_HARMAN = function (profileType = '') {
  return profileType.toLocaleLowerCase() == 'HARMAN Professional AV Network'.toLocaleLowerCase();
}

export const CONTRAST_COLOR = (hexColor) => {
  hexColor = hexColor.replace(/^#/, '');
  let r = parseInt(hexColor.substring(0, 2), 16);
  let g = parseInt(hexColor.substring(2, 4), 16);
  let b = parseInt(hexColor.substring(4, 6), 16);
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;
  if (brightness > 200) {
    return '#000000';
  } else {
    return `#${hexColor}`;
  }
}
